/**
 * MembersOnlyLoginPrompt Component
 * 
 * Gate component shown when unauthenticated users try to access members-only events.
 * Part of Issue #604 - Allow public access to public events.
 */

import { Lock } from 'lucide-react';
import Button from './Button';

interface MembersOnlyLoginPromptProps {
  onLoginClick: () => void;
}

export function MembersOnlyLoginPrompt({ onLoginClick }: MembersOnlyLoginPromptProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-oro-bg">
      <Lock className="w-16 h-16 text-text-muted mb-4" />
      <h2 className="text-xl font-semibold mb-2 text-text-primary">Members Only Event</h2>
      <p className="text-text-secondary mb-6 text-center">Please log in to view this event</p>
      <Button onClick={onLoginClick}>Log In</Button>
    </div>
  );
}
